import { SxProps, Theme } from '@mui/system';

export default {
  container: {
    display: 'flex',
    alignItems: 'center',
    mt: '5px',
  },
  searchContainer: {
    mr: 2,
    mb: '3px',
  },
  create: {
    ':hover': {
      cursor: 'pointer',
    },
  },
} satisfies Record<string, SxProps<Theme>>;
